export const THEYSAID_PANEL_URL_CHANNEL = 'theysaid-panel';
